// generated by tools/tokens.py from tokens/*.json -- do not edit.

export type Brand = "terica" | "humint";
export type Mode = 'light' | 'dark';
export interface TokenInfo { name: string; type: string; values: Record<Brand, Record<Mode, string>> }
export interface PairInfo { fg: string; bg: string; kind: 'text' | 'ui'; min: number; ratios: Record<Brand, Record<Mode, number>> }

export const BRANDS: Brand[] = ["terica", "humint"];
export const DEFAULT_BRAND: Brand = "terica";

export const TOKENS: TokenInfo[] = [
  {
    "name": "accent",
    "type": "color",
    "values": {
      "terica": {
        "light": "#0369a1",
        "dark": "#0ea5e9"
      },
      "humint": {
        "light": "#ea580c",
        "dark": "#f97316"
      }
    }
  },
  {
    "name": "accent-display",
    "type": "color",
    "values": {
      "terica": {
        "light": "#075985",
        "dark": "#7dd3fc"
      },
      "humint": {
        "light": "#9a3412",
        "dark": "#fdba74"
      }
    }
  },
  {
    "name": "accent-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#e6f0f8",
        "dark": "#0a2739"
      },
      "humint": {
        "light": "#fcebe2",
        "dark": "#371d0b"
      }
    }
  },
  {
    "name": "accent-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#ffffff",
        "dark": "#082f49"
      },
      "humint": {
        "light": "#0c0a09",
        "dark": "#431407"
      }
    }
  },
  {
    "name": "action-bg",
    "type": "color",
    "values": {
      "terica": {
        "light": "#0369a1",
        "dark": "#0ea5e9"
      },
      "humint": {
        "light": "#c2410c",
        "dark": "#f97316"
      }
    }
  },
  {
    "name": "action-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#ffffff",
        "dark": "#082f49"
      },
      "humint": {
        "light": "#ffffff",
        "dark": "#431407"
      }
    }
  },
  {
    "name": "badge-batch-bg",
    "type": "color",
    "values": {
      "terica": {
        "light": "#f2f8ff",
        "dark": "#0f1d33"
      },
      "humint": {
        "light": "#f2f8ff",
        "dark": "#0f1d33"
      }
    }
  },
  {
    "name": "badge-batch-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#1d4ed8",
        "dark": "#93c5fd"
      },
      "humint": {
        "light": "#1d4ed8",
        "dark": "#93c5fd"
      }
    }
  },
  {
    "name": "badge-hold-bg",
    "type": "color",
    "values": {
      "terica": {
        "light": "#f4f4f5",
        "dark": "#27272b"
      },
      "humint": {
        "light": "#f5f5f4",
        "dark": "#292524"
      }
    }
  },
  {
    "name": "badge-hold-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#3f3f46",
        "dark": "#e4e4e7"
      },
      "humint": {
        "light": "#44403c",
        "dark": "#e7e5e4"
      }
    }
  },
  {
    "name": "badge-needs-report-bg",
    "type": "color",
    "values": {
      "terica": {
        "light": "#faefe1",
        "dark": "#362509"
      },
      "humint": {
        "light": "#faefe1",
        "dark": "#362509"
      }
    }
  },
  {
    "name": "badge-needs-report-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#92400e",
        "dark": "#fcd34d"
      },
      "humint": {
        "light": "#92400e",
        "dark": "#fcd34d"
      }
    }
  },
  {
    "name": "badge-unparsed-bg",
    "type": "color",
    "values": {
      "terica": {
        "light": "#fbe5e5",
        "dark": "#351414"
      },
      "humint": {
        "light": "#fbe5e5",
        "dark": "#351414"
      }
    }
  },
  {
    "name": "badge-unparsed-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#b91c1c",
        "dark": "#fca5a5"
      },
      "humint": {
        "light": "#b91c1c",
        "dark": "#fca5a5"
      }
    }
  },
  {
    "name": "checks-fail",
    "type": "color",
    "values": {
      "terica": {
        "light": "#dc2626",
        "dark": "#ef4444"
      },
      "humint": {
        "light": "#dc2626",
        "dark": "#ef4444"
      }
    }
  },
  {
    "name": "checks-fail-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#b91c1c",
        "dark": "#fca5a5"
      },
      "humint": {
        "light": "#b91c1c",
        "dark": "#fca5a5"
      }
    }
  },
  {
    "name": "checks-pass",
    "type": "color",
    "values": {
      "terica": {
        "light": "#059669",
        "dark": "#10b981"
      },
      "humint": {
        "light": "#059669",
        "dark": "#10b981"
      }
    }
  },
  {
    "name": "checks-pass-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#047857",
        "dark": "#6ee7b7"
      },
      "humint": {
        "light": "#047857",
        "dark": "#6ee7b7"
      }
    }
  },
  {
    "name": "checks-pending",
    "type": "color",
    "values": {
      "terica": {
        "light": "#d97706",
        "dark": "#f59e0b"
      },
      "humint": {
        "light": "#d97706",
        "dark": "#f59e0b"
      }
    }
  },
  {
    "name": "checks-pending-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#92400e",
        "dark": "#fcd34d"
      },
      "humint": {
        "light": "#92400e",
        "dark": "#fcd34d"
      }
    }
  },
  {
    "name": "danger",
    "type": "color",
    "values": {
      "terica": {
        "light": "#dc2626",
        "dark": "#ef4444"
      },
      "humint": {
        "light": "#dc2626",
        "dark": "#ef4444"
      }
    }
  },
  {
    "name": "danger-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#fbe5e5",
        "dark": "#351414"
      },
      "humint": {
        "light": "#fbe5e5",
        "dark": "#351414"
      }
    }
  },
  {
    "name": "danger-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#b91c1c",
        "dark": "#fca5a5"
      },
      "humint": {
        "light": "#b91c1c",
        "dark": "#fca5a5"
      }
    }
  },
  {
    "name": "fade-edge",
    "type": "dimension",
    "values": {
      "terica": {
        "light": "24px",
        "dark": "24px"
      },
      "humint": {
        "light": "24px",
        "dark": "24px"
      }
    }
  },
  {
    "name": "focus-ring",
    "type": "color",
    "values": {
      "terica": {
        "light": "#0369a1",
        "dark": "#0ea5e9"
      },
      "humint": {
        "light": "#ea580c",
        "dark": "#f97316"
      }
    }
  },
  {
    "name": "font-mono",
    "type": "fontFamily",
    "values": {
      "terica": {
        "light": "\"JetBrains Mono\", ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace",
        "dark": "\"JetBrains Mono\", ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace"
      },
      "humint": {
        "light": "\"JetBrains Mono\", ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace",
        "dark": "\"JetBrains Mono\", ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace"
      }
    }
  },
  {
    "name": "font-sans",
    "type": "fontFamily",
    "values": {
      "terica": {
        "light": "Inter, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
        "dark": "Inter, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif"
      },
      "humint": {
        "light": "Inter, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif",
        "dark": "Inter, system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif"
      }
    }
  },
  {
    "name": "hairline",
    "type": "color",
    "values": {
      "terica": {
        "light": "#e4e4e7",
        "dark": "#27272a"
      },
      "humint": {
        "light": "#e7e5e4",
        "dark": "#292524"
      }
    }
  },
  {
    "name": "hairline-strong",
    "type": "color",
    "values": {
      "terica": {
        "light": "#d4d4d8",
        "dark": "#3f3f46"
      },
      "humint": {
        "light": "#d6d3d1",
        "dark": "#44403c"
      }
    }
  },
  {
    "name": "ink-body",
    "type": "color",
    "values": {
      "terica": {
        "light": "#3f3f46",
        "dark": "#e4e4e7"
      },
      "humint": {
        "light": "#44403c",
        "dark": "#e7e5e4"
      }
    }
  },
  {
    "name": "ink-display",
    "type": "color",
    "values": {
      "terica": {
        "light": "#18181b",
        "dark": "#fafafa"
      },
      "humint": {
        "light": "#1c1917",
        "dark": "#fafaf9"
      }
    }
  },
  {
    "name": "ink-muted",
    "type": "color",
    "values": {
      "terica": {
        "light": "#71717a",
        "dark": "#b4b4bd"
      },
      "humint": {
        "light": "#78716c",
        "dark": "#a8a29e"
      }
    }
  },
  {
    "name": "label-bug-bg",
    "type": "color",
    "values": {
      "terica": {
        "light": "#fbe5e5",
        "dark": "#351414"
      },
      "humint": {
        "light": "#fbe5e5",
        "dark": "#351414"
      }
    }
  },
  {
    "name": "label-bug-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#b91c1c",
        "dark": "#fca5a5"
      },
      "humint": {
        "light": "#b91c1c",
        "dark": "#fca5a5"
      }
    }
  },
  {
    "name": "label-epic-bg",
    "type": "color",
    "values": {
      "terica": {
        "light": "#eeeafc",
        "dark": "#221436"
      },
      "humint": {
        "light": "#eeeafc",
        "dark": "#221436"
      }
    }
  },
  {
    "name": "label-epic-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#6d28d9",
        "dark": "#c4b5fd"
      },
      "humint": {
        "light": "#6d28d9",
        "dark": "#c4b5fd"
      }
    }
  },
  {
    "name": "label-triage-bg",
    "type": "color",
    "values": {
      "terica": {
        "light": "#faefe1",
        "dark": "#362509"
      },
      "humint": {
        "light": "#faefe1",
        "dark": "#362509"
      }
    }
  },
  {
    "name": "label-triage-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#92400e",
        "dark": "#fcd34d"
      },
      "humint": {
        "light": "#92400e",
        "dark": "#fcd34d"
      }
    }
  },
  {
    "name": "page",
    "type": "color",
    "values": {
      "terica": {
        "light": "#ffffff",
        "dark": "#09090b"
      },
      "humint": {
        "light": "#ffffff",
        "dark": "#0c0a09"
      }
    }
  },
  {
    "name": "radius",
    "type": "dimension",
    "values": {
      "terica": {
        "light": "8px",
        "dark": "8px"
      },
      "humint": {
        "light": "8px",
        "dark": "8px"
      }
    }
  },
  {
    "name": "radius-lg",
    "type": "dimension",
    "values": {
      "terica": {
        "light": "10px",
        "dark": "10px"
      },
      "humint": {
        "light": "10px",
        "dark": "10px"
      }
    }
  },
  {
    "name": "scrim",
    "type": "color",
    "values": {
      "terica": {
        "light": "#18181b52",
        "dark": "#0000008c"
      },
      "humint": {
        "light": "#1c191752",
        "dark": "#0000008c"
      }
    }
  },
  {
    "name": "signal",
    "type": "color",
    "values": {
      "terica": {
        "light": "#3b82f6",
        "dark": "#60a5fa"
      },
      "humint": {
        "light": "#3b82f6",
        "dark": "#60a5fa"
      }
    }
  },
  {
    "name": "signal-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#f2f8ff",
        "dark": "#0f1d33"
      },
      "humint": {
        "light": "#f2f8ff",
        "dark": "#0f1d33"
      }
    }
  },
  {
    "name": "signal-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#1d4ed8",
        "dark": "#93c5fd"
      },
      "humint": {
        "light": "#1d4ed8",
        "dark": "#93c5fd"
      }
    }
  },
  {
    "name": "status-exploring",
    "type": "color",
    "values": {
      "terica": {
        "light": "#7c3aed",
        "dark": "#8b5cf6"
      },
      "humint": {
        "light": "#7c3aed",
        "dark": "#8b5cf6"
      }
    }
  },
  {
    "name": "status-exploring-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#eeeafc",
        "dark": "#221436"
      },
      "humint": {
        "light": "#eeeafc",
        "dark": "#221436"
      }
    }
  },
  {
    "name": "status-exploring-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#6d28d9",
        "dark": "#c4b5fd"
      },
      "humint": {
        "light": "#6d28d9",
        "dark": "#c4b5fd"
      }
    }
  },
  {
    "name": "status-inbox",
    "type": "color",
    "values": {
      "terica": {
        "light": "#71717a",
        "dark": "#a1a1aa"
      },
      "humint": {
        "light": "#78716c",
        "dark": "#a8a29e"
      }
    }
  },
  {
    "name": "status-inbox-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#f4f4f5",
        "dark": "#27272b"
      },
      "humint": {
        "light": "#f5f5f4",
        "dark": "#292524"
      }
    }
  },
  {
    "name": "status-inbox-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#3f3f46",
        "dark": "#e4e4e7"
      },
      "humint": {
        "light": "#44403c",
        "dark": "#e7e5e4"
      }
    }
  },
  {
    "name": "status-inflight",
    "type": "color",
    "values": {
      "terica": {
        "light": "#d97706",
        "dark": "#f59e0b"
      },
      "humint": {
        "light": "#d97706",
        "dark": "#f59e0b"
      }
    }
  },
  {
    "name": "status-inflight-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#faefe1",
        "dark": "#362509"
      },
      "humint": {
        "light": "#faefe1",
        "dark": "#362509"
      }
    }
  },
  {
    "name": "status-inflight-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#92400e",
        "dark": "#fcd34d"
      },
      "humint": {
        "light": "#92400e",
        "dark": "#fcd34d"
      }
    }
  },
  {
    "name": "status-locked",
    "type": "color",
    "values": {
      "terica": {
        "light": "#3b82f6",
        "dark": "#60a5fa"
      },
      "humint": {
        "light": "#3b82f6",
        "dark": "#60a5fa"
      }
    }
  },
  {
    "name": "status-locked-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#f2f8ff",
        "dark": "#0f1d33"
      },
      "humint": {
        "light": "#f2f8ff",
        "dark": "#0f1d33"
      }
    }
  },
  {
    "name": "status-locked-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#1d4ed8",
        "dark": "#93c5fd"
      },
      "humint": {
        "light": "#1d4ed8",
        "dark": "#93c5fd"
      }
    }
  },
  {
    "name": "status-review",
    "type": "color",
    "values": {
      "terica": {
        "light": "#0369a1",
        "dark": "#0ea5e9"
      },
      "humint": {
        "light": "#ea580c",
        "dark": "#f97316"
      }
    }
  },
  {
    "name": "status-review-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#e6f0f8",
        "dark": "#0a2739"
      },
      "humint": {
        "light": "#fcebe2",
        "dark": "#371d0b"
      }
    }
  },
  {
    "name": "status-review-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#075985",
        "dark": "#7dd3fc"
      },
      "humint": {
        "light": "#9a3412",
        "dark": "#fdba74"
      }
    }
  },
  {
    "name": "status-shipped",
    "type": "color",
    "values": {
      "terica": {
        "light": "#059669",
        "dark": "#10b981"
      },
      "humint": {
        "light": "#059669",
        "dark": "#10b981"
      }
    }
  },
  {
    "name": "status-shipped-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#e1f2ed",
        "dark": "#0d2a1f"
      },
      "humint": {
        "light": "#e1f2ed",
        "dark": "#0d2a1f"
      }
    }
  },
  {
    "name": "status-shipped-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#047857",
        "dark": "#6ee7b7"
      },
      "humint": {
        "light": "#047857",
        "dark": "#6ee7b7"
      }
    }
  },
  {
    "name": "success",
    "type": "color",
    "values": {
      "terica": {
        "light": "#059669",
        "dark": "#10b981"
      },
      "humint": {
        "light": "#059669",
        "dark": "#10b981"
      }
    }
  },
  {
    "name": "success-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#e1f2ed",
        "dark": "#0d2a1f"
      },
      "humint": {
        "light": "#e1f2ed",
        "dark": "#0d2a1f"
      }
    }
  },
  {
    "name": "success-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#047857",
        "dark": "#6ee7b7"
      },
      "humint": {
        "light": "#047857",
        "dark": "#6ee7b7"
      }
    }
  },
  {
    "name": "surface",
    "type": "color",
    "values": {
      "terica": {
        "light": "#fafafa",
        "dark": "#18181b"
      },
      "humint": {
        "light": "#fafaf9",
        "dark": "#1c1917"
      }
    }
  },
  {
    "name": "surface-raised",
    "type": "color",
    "values": {
      "terica": {
        "light": "#ffffff",
        "dark": "#1c1c1f"
      },
      "humint": {
        "light": "#ffffff",
        "dark": "#211d1b"
      }
    }
  },
  {
    "name": "warning",
    "type": "color",
    "values": {
      "terica": {
        "light": "#d97706",
        "dark": "#f59e0b"
      },
      "humint": {
        "light": "#d97706",
        "dark": "#f59e0b"
      }
    }
  },
  {
    "name": "warning-faded",
    "type": "color",
    "values": {
      "terica": {
        "light": "#faefe1",
        "dark": "#362509"
      },
      "humint": {
        "light": "#faefe1",
        "dark": "#362509"
      }
    }
  },
  {
    "name": "warning-ink",
    "type": "color",
    "values": {
      "terica": {
        "light": "#92400e",
        "dark": "#fcd34d"
      },
      "humint": {
        "light": "#92400e",
        "dark": "#fcd34d"
      }
    }
  }
];

export const PAIRS: PairInfo[] = [
  {
    "fg": "ink-body",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 10.44,
        "dark": 15.68
      },
      "humint": {
        "light": 10.27,
        "dark": 15.73
      }
    }
  },
  {
    "fg": "ink-display",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 17.72,
        "dark": 19.06
      },
      "humint": {
        "light": 17.49,
        "dark": 18.92
      }
    }
  },
  {
    "fg": "ink-muted",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 4.83,
        "dark": 9.67
      },
      "humint": {
        "light": 4.8,
        "dark": 7.83
      }
    }
  },
  {
    "fg": "accent-display",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 7.56,
        "dark": 11.93
      },
      "humint": {
        "light": 7.31,
        "dark": 11.71
      }
    }
  },
  {
    "fg": "checks-pass",
    "bg": "page",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.77,
        "dark": 7.84
      },
      "humint": {
        "light": 3.77,
        "dark": 7.79
      }
    }
  },
  {
    "fg": "checks-fail",
    "bg": "page",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 4.83,
        "dark": 5.29
      },
      "humint": {
        "light": 4.83,
        "dark": 5.25
      }
    }
  },
  {
    "fg": "checks-pending",
    "bg": "page",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.19,
        "dark": 9.26
      },
      "humint": {
        "light": 3.19,
        "dark": 9.2
      }
    }
  },
  {
    "fg": "focus-ring",
    "bg": "page",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 5.93,
        "dark": 7.18
      },
      "humint": {
        "light": 3.56,
        "dark": 7.05
      }
    }
  },
  {
    "fg": "ink-body",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 10.01,
        "dark": 13.96
      },
      "humint": {
        "light": 9.84,
        "dark": 13.93
      }
    }
  },
  {
    "fg": "ink-display",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 16.97,
        "dark": 16.97
      },
      "humint": {
        "light": 16.74,
        "dark": 16.74
      }
    }
  },
  {
    "fg": "ink-muted",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 4.63,
        "dark": 8.61
      },
      "humint": {
        "light": 4.59,
        "dark": 6.93
      }
    }
  },
  {
    "fg": "accent-display",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 7.25,
        "dark": 10.63
      },
      "humint": {
        "light": 7.0,
        "dark": 10.37
      }
    }
  },
  {
    "fg": "checks-pass",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.61,
        "dark": 6.98
      },
      "humint": {
        "light": 3.61,
        "dark": 6.89
      }
    }
  },
  {
    "fg": "checks-fail",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 4.63,
        "dark": 4.71
      },
      "humint": {
        "light": 4.62,
        "dark": 4.65
      }
    }
  },
  {
    "fg": "checks-pending",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.05,
        "dark": 8.25
      },
      "humint": {
        "light": 3.05,
        "dark": 8.14
      }
    }
  },
  {
    "fg": "focus-ring",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 5.68,
        "dark": 6.39
      },
      "humint": {
        "light": 3.41,
        "dark": 6.24
      }
    }
  },
  {
    "fg": "ink-body",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 10.44,
        "dark": 13.4
      },
      "humint": {
        "light": 10.27,
        "dark": 13.31
      }
    }
  },
  {
    "fg": "ink-display",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 17.72,
        "dark": 16.29
      },
      "humint": {
        "light": 17.49,
        "dark": 16.01
      }
    }
  },
  {
    "fg": "ink-muted",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 4.83,
        "dark": 8.26
      },
      "humint": {
        "light": 4.8,
        "dark": 6.63
      }
    }
  },
  {
    "fg": "accent-display",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 7.56,
        "dark": 10.2
      },
      "humint": {
        "light": 7.31,
        "dark": 9.91
      }
    }
  },
  {
    "fg": "checks-pass",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.77,
        "dark": 6.7
      },
      "humint": {
        "light": 3.77,
        "dark": 6.59
      }
    }
  },
  {
    "fg": "checks-fail",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 4.83,
        "dark": 4.52
      },
      "humint": {
        "light": 4.83,
        "dark": 4.44
      }
    }
  },
  {
    "fg": "checks-pending",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.19,
        "dark": 7.92
      },
      "humint": {
        "light": 3.19,
        "dark": 7.78
      }
    }
  },
  {
    "fg": "focus-ring",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 5.93,
        "dark": 6.13
      },
      "humint": {
        "light": 3.56,
        "dark": 5.96
      }
    }
  },
  {
    "fg": "status-inbox-ink",
    "bg": "status-inbox-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 9.5,
        "dark": 11.73
      },
      "humint": {
        "light": 9.42,
        "dark": 12.08
      }
    }
  },
  {
    "fg": "status-inbox",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 4.63,
        "dark": 6.91
      },
      "humint": {
        "light": 4.59,
        "dark": 6.93
      }
    }
  },
  {
    "fg": "status-inbox",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 4.83,
        "dark": 6.63
      },
      "humint": {
        "light": 4.8,
        "dark": 6.63
      }
    }
  },
  {
    "fg": "status-exploring-ink",
    "bg": "status-exploring-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.03,
        "dark": 9.31
      },
      "humint": {
        "light": 6.03,
        "dark": 9.31
      }
    }
  },
  {
    "fg": "status-exploring",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 5.46,
        "dark": 4.18
      },
      "humint": {
        "light": 5.46,
        "dark": 4.13
      }
    }
  },
  {
    "fg": "status-exploring",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 5.7,
        "dark": 4.01
      },
      "humint": {
        "light": 5.7,
        "dark": 3.95
      }
    }
  },
  {
    "fg": "status-locked-ink",
    "bg": "status-locked-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.27,
        "dark": 9.36
      },
      "humint": {
        "light": 6.27,
        "dark": 9.36
      }
    }
  },
  {
    "fg": "status-locked",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.52,
        "dark": 6.97
      },
      "humint": {
        "light": 3.52,
        "dark": 6.88
      }
    }
  },
  {
    "fg": "status-locked",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.68,
        "dark": 6.69
      },
      "humint": {
        "light": 3.68,
        "dark": 6.58
      }
    }
  },
  {
    "fg": "status-inflight-ink",
    "bg": "status-inflight-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.25,
        "dark": 10.22
      },
      "humint": {
        "light": 6.25,
        "dark": 10.22
      }
    }
  },
  {
    "fg": "status-inflight",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.05,
        "dark": 8.25
      },
      "humint": {
        "light": 3.05,
        "dark": 8.14
      }
    }
  },
  {
    "fg": "status-inflight",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.19,
        "dark": 7.92
      },
      "humint": {
        "light": 3.19,
        "dark": 7.78
      }
    }
  },
  {
    "fg": "status-review-ink",
    "bg": "status-review-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.55,
        "dark": 9.25
      },
      "humint": {
        "light": 6.31,
        "dark": 9.27
      }
    }
  },
  {
    "fg": "status-review",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 5.68,
        "dark": 6.39
      },
      "humint": {
        "light": 3.41,
        "dark": 6.24
      }
    }
  },
  {
    "fg": "status-review",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 5.93,
        "dark": 6.13
      },
      "humint": {
        "light": 3.56,
        "dark": 5.96
      }
    }
  },
  {
    "fg": "status-shipped-ink",
    "bg": "status-shipped-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 4.73,
        "dark": 10.07
      },
      "humint": {
        "light": 4.73,
        "dark": 10.07
      }
    }
  },
  {
    "fg": "status-shipped",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.61,
        "dark": 6.98
      },
      "humint": {
        "light": 3.61,
        "dark": 6.89
      }
    }
  },
  {
    "fg": "status-shipped",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.77,
        "dark": 6.7
      },
      "humint": {
        "light": 3.77,
        "dark": 6.59
      }
    }
  },
  {
    "fg": "badge-hold-ink",
    "bg": "badge-hold-bg",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 9.5,
        "dark": 11.73
      },
      "humint": {
        "light": 9.42,
        "dark": 12.08
      }
    }
  },
  {
    "fg": "badge-unparsed-ink",
    "bg": "badge-unparsed-bg",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.37,
        "dark": 8.77
      },
      "humint": {
        "light": 5.37,
        "dark": 8.77
      }
    }
  },
  {
    "fg": "badge-needs-report-ink",
    "bg": "badge-needs-report-bg",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.25,
        "dark": 10.22
      },
      "humint": {
        "light": 6.25,
        "dark": 10.22
      }
    }
  },
  {
    "fg": "label-bug-ink",
    "bg": "label-bug-bg",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.37,
        "dark": 8.77
      },
      "humint": {
        "light": 5.37,
        "dark": 8.77
      }
    }
  },
  {
    "fg": "label-triage-ink",
    "bg": "label-triage-bg",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.25,
        "dark": 10.22
      },
      "humint": {
        "light": 6.25,
        "dark": 10.22
      }
    }
  },
  {
    "fg": "label-epic-ink",
    "bg": "label-epic-bg",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.03,
        "dark": 9.31
      },
      "humint": {
        "light": 6.03,
        "dark": 9.31
      }
    }
  },
  {
    "fg": "accent-ink",
    "bg": "accent",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.93,
        "dark": 5.01
      },
      "humint": {
        "light": 5.55,
        "dark": 5.58
      }
    }
  },
  {
    "fg": "action-ink",
    "bg": "action-bg",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.93,
        "dark": 5.01
      },
      "humint": {
        "light": 5.18,
        "dark": 5.58
      }
    }
  },
  {
    "fg": "ink-body",
    "bg": "accent-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 9.04,
        "dark": 12.15
      },
      "humint": {
        "light": 8.86,
        "dark": 12.45
      }
    }
  },
  {
    "fg": "checks-pass-ink",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.48,
        "dark": 13.05
      },
      "humint": {
        "light": 5.48,
        "dark": 12.96
      }
    }
  },
  {
    "fg": "checks-pass-ink",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.25,
        "dark": 11.62
      },
      "humint": {
        "light": 5.25,
        "dark": 11.47
      }
    }
  },
  {
    "fg": "checks-pass-ink",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.48,
        "dark": 11.15
      },
      "humint": {
        "light": 5.48,
        "dark": 10.97
      }
    }
  },
  {
    "fg": "checks-fail-ink",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.47,
        "dark": 10.48
      },
      "humint": {
        "light": 6.47,
        "dark": 10.41
      }
    }
  },
  {
    "fg": "checks-fail-ink",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.2,
        "dark": 9.33
      },
      "humint": {
        "light": 6.19,
        "dark": 9.21
      }
    }
  },
  {
    "fg": "checks-fail-ink",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.47,
        "dark": 8.96
      },
      "humint": {
        "light": 6.47,
        "dark": 8.81
      }
    }
  },
  {
    "fg": "checks-pending-ink",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 7.09,
        "dark": 13.8
      },
      "humint": {
        "light": 7.09,
        "dark": 13.7
      }
    }
  },
  {
    "fg": "checks-pending-ink",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.79,
        "dark": 12.29
      },
      "humint": {
        "light": 6.79,
        "dark": 12.13
      }
    }
  },
  {
    "fg": "checks-pending-ink",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 7.09,
        "dark": 11.79
      },
      "humint": {
        "light": 7.09,
        "dark": 11.59
      }
    }
  },
  {
    "fg": "ink-display",
    "bg": "accent-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 15.34,
        "dark": 14.77
      },
      "humint": {
        "light": 15.09,
        "dark": 14.97
      }
    }
  },
  {
    "fg": "accent-display",
    "bg": "accent-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.55,
        "dark": 9.25
      },
      "humint": {
        "light": 6.31,
        "dark": 9.27
      }
    }
  },
  {
    "fg": "ink-display",
    "bg": "badge-hold-bg",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 16.12,
        "dark": 14.26
      },
      "humint": {
        "light": 16.03,
        "dark": 14.52
      }
    }
  },
  {
    "fg": "page",
    "bg": "ink-display",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 17.72,
        "dark": 19.06
      },
      "humint": {
        "light": 17.49,
        "dark": 18.92
      }
    }
  },
  {
    "fg": "badge-batch-ink",
    "bg": "badge-batch-bg",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.27,
        "dark": 9.36
      },
      "humint": {
        "light": 6.27,
        "dark": 9.36
      }
    }
  },
  {
    "fg": "success-ink",
    "bg": "success-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 4.73,
        "dark": 10.07
      },
      "humint": {
        "light": 4.73,
        "dark": 10.07
      }
    }
  },
  {
    "fg": "success-ink",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.48,
        "dark": 13.05
      },
      "humint": {
        "light": 5.48,
        "dark": 12.96
      }
    }
  },
  {
    "fg": "success-ink",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.25,
        "dark": 11.62
      },
      "humint": {
        "light": 5.25,
        "dark": 11.47
      }
    }
  },
  {
    "fg": "success-ink",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.48,
        "dark": 11.15
      },
      "humint": {
        "light": 5.48,
        "dark": 10.97
      }
    }
  },
  {
    "fg": "success",
    "bg": "page",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.77,
        "dark": 7.84
      },
      "humint": {
        "light": 3.77,
        "dark": 7.79
      }
    }
  },
  {
    "fg": "success",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.61,
        "dark": 6.98
      },
      "humint": {
        "light": 3.61,
        "dark": 6.89
      }
    }
  },
  {
    "fg": "success",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.77,
        "dark": 6.7
      },
      "humint": {
        "light": 3.77,
        "dark": 6.59
      }
    }
  },
  {
    "fg": "warning-ink",
    "bg": "warning-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.25,
        "dark": 10.22
      },
      "humint": {
        "light": 6.25,
        "dark": 10.22
      }
    }
  },
  {
    "fg": "warning-ink",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 7.09,
        "dark": 13.8
      },
      "humint": {
        "light": 7.09,
        "dark": 13.7
      }
    }
  },
  {
    "fg": "warning-ink",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.79,
        "dark": 12.29
      },
      "humint": {
        "light": 6.79,
        "dark": 12.13
      }
    }
  },
  {
    "fg": "warning-ink",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 7.09,
        "dark": 11.79
      },
      "humint": {
        "light": 7.09,
        "dark": 11.59
      }
    }
  },
  {
    "fg": "warning",
    "bg": "page",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.19,
        "dark": 9.26
      },
      "humint": {
        "light": 3.19,
        "dark": 9.2
      }
    }
  },
  {
    "fg": "warning",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.05,
        "dark": 8.25
      },
      "humint": {
        "light": 3.05,
        "dark": 8.14
      }
    }
  },
  {
    "fg": "warning",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.19,
        "dark": 7.92
      },
      "humint": {
        "light": 3.19,
        "dark": 7.78
      }
    }
  },
  {
    "fg": "danger-ink",
    "bg": "danger-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 5.37,
        "dark": 8.77
      },
      "humint": {
        "light": 5.37,
        "dark": 8.77
      }
    }
  },
  {
    "fg": "danger-ink",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.47,
        "dark": 10.48
      },
      "humint": {
        "light": 6.47,
        "dark": 10.41
      }
    }
  },
  {
    "fg": "danger-ink",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.2,
        "dark": 9.33
      },
      "humint": {
        "light": 6.19,
        "dark": 9.21
      }
    }
  },
  {
    "fg": "danger-ink",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.47,
        "dark": 8.96
      },
      "humint": {
        "light": 6.47,
        "dark": 8.81
      }
    }
  },
  {
    "fg": "danger",
    "bg": "page",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 4.83,
        "dark": 5.29
      },
      "humint": {
        "light": 4.83,
        "dark": 5.25
      }
    }
  },
  {
    "fg": "danger",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 4.63,
        "dark": 4.71
      },
      "humint": {
        "light": 4.62,
        "dark": 4.65
      }
    }
  },
  {
    "fg": "danger",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 4.83,
        "dark": 4.52
      },
      "humint": {
        "light": 4.83,
        "dark": 4.44
      }
    }
  },
  {
    "fg": "signal-ink",
    "bg": "signal-faded",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.27,
        "dark": 9.36
      },
      "humint": {
        "light": 6.27,
        "dark": 9.36
      }
    }
  },
  {
    "fg": "signal-ink",
    "bg": "page",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.7,
        "dark": 11.03
      },
      "humint": {
        "light": 6.7,
        "dark": 10.96
      }
    }
  },
  {
    "fg": "signal-ink",
    "bg": "surface",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.42,
        "dark": 9.82
      },
      "humint": {
        "light": 6.42,
        "dark": 9.7
      }
    }
  },
  {
    "fg": "signal-ink",
    "bg": "surface-raised",
    "kind": "text",
    "min": 4.5,
    "ratios": {
      "terica": {
        "light": 6.7,
        "dark": 9.43
      },
      "humint": {
        "light": 6.7,
        "dark": 9.27
      }
    }
  },
  {
    "fg": "signal",
    "bg": "page",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.68,
        "dark": 7.83
      },
      "humint": {
        "light": 3.68,
        "dark": 7.77
      }
    }
  },
  {
    "fg": "signal",
    "bg": "surface",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.52,
        "dark": 6.97
      },
      "humint": {
        "light": 3.52,
        "dark": 6.88
      }
    }
  },
  {
    "fg": "signal",
    "bg": "surface-raised",
    "kind": "ui",
    "min": 3.0,
    "ratios": {
      "terica": {
        "light": 3.68,
        "dark": 6.69
      },
      "humint": {
        "light": 3.68,
        "dark": 6.58
      }
    }
  }
];
